import React, { Component } from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';


class LoadingDL extends Component {
render () { 
    return (
        <Box sx={{mt: 0, mb: 0, p: 0, width: '100%' }}>
        <Skeleton />
        <Skeleton animation="wave" />
        <Skeleton animation={false} />
        </Box>
    );
    }
}

export default LoadingDL
